import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsDialogComponent } from '@wms/components';
import { CopilotModalContentComponent, CopilotService } from '@wms/copilot';
import { WmsWorkspaceManagerService } from '@wms/app/workspace';
import { DialogService } from '@wms/app/services';
import { VersionManagerPipe } from '@wms/app/core';

@Component({
  selector: 'wms-copilot',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    CopilotModalContentComponent,
    VersionManagerPipe
  ],
  templateUrl: './copilot.component.html',
  styleUrls: ['./copilot.component.less']
})
export class CopilotComponent extends BaseComponent {

  customClasses: string = '';
  displayText: string = this.locale.LABEL_COPILOT;

  constructor(public copilotService: CopilotService, public wmsWorkspaceManager: WmsWorkspaceManagerService,public dialogService: DialogService) {
    super();
  }

  setCustomClass(size: string) {
    this.customClasses = size === 'small'
      ? 'copilot-modal small-dialog'
      : 'copilot-modal large-dialog';
  }

  onCopilotBtnClick() {
    this.setCustomClass('small');
    this.displayText = this.locale.LABEL_COPILOT;
    this.copilotService.setActiveScreen('prompt-screen');
  }

  onMouseHover() {
    this.displayText = this.locale.LABEL_COPILOT_HELP_MSG;
  }

  onMouseLeave() {
    this.displayText = this.locale.LABEL_COPILOT;
  }

}
